import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { ExpenseTable } from '@/components/Pages/Expenses/ExpenseTable';
import { Box } from '@mui/joy';
import { CreateEditExpenseModal } from '@/components/Pages/Expenses/CreateEditExpenseModal';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/expenses/')({
  component: ExpensesPage,
  head: () => pageTitle('Gastos'),
});

function ExpensesPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('EXPENSES_READ');
  const canWrite = hasClaim('EXPENSES_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditExpenseModal />
        </Box>
      )}
      <ExpenseTable
        initialFilters={{ CategoryLedger: 'Expense' }}
        emptyMessage='No hay gastos disponibles'
        errorTitle='Error al cargar los gastos'
      />
    </Box>
  );
}
